import { Outlet, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/auth-store';
import { api } from '../lib/api-client';

export function AppShell() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);

  async function handleLogout() {
    try {
      await api<void>('/api/auth/logout', { method: 'POST', auth: false });
    } finally {
      clear();
    }
  }

  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-6">
            <h1 className="text-lg font-bold text-brand-700">{t('app.title')}</h1>
            <nav className="flex gap-4 text-sm">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  isActive ? 'text-brand-700 font-medium' : 'text-slate-600 hover:text-slate-900'
                }
              >
                {t('nav.dashboard')}
              </NavLink>
              <NavLink
                to="/poc/mpg-grid"
                className={({ isActive }) =>
                  isActive ? 'text-brand-700 font-medium' : 'text-slate-600 hover:text-slate-900'
                }
              >
                {t('nav.mpgPoc')}
              </NavLink>
              <NavLink
                to="/settings"
                className={({ isActive }) =>
                  isActive ? 'text-brand-700 font-medium' : 'text-slate-600 hover:text-slate-900'
                }
              >
                {t('nav.settings')}
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-600">
            <span>{user?.email}</span>
            <button
              type="button"
              onClick={handleLogout}
              className="text-slate-500 underline-offset-2 hover:text-slate-900 hover:underline"
            >
              {t('nav.logout')}
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
